module.exports = __webpack_public_path__ + "static/Propel-e2f8358633b5172795ed0242d6d81dab.jpg";